function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useTopicPage_Views_ArchiveQuery, ItemType, useTopicPage_Views_TrashQuery, ItemMemberLevel } from "sprout-graphql";
import { useParams, useLocation, Redirect } from "react-router-dom";
import { parse } from "query-string";
import update from "immutability-helper";
import { Glitch, NotFound } from "@sprout/views";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import Head from "@sprout/client-layout/dist/Head";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import { getItemUrl } from "sprout-lib";
import TopicPagePage from "../TopicPage_Page";
import TopicPageViewsTabsMain from "./TopicPage_Views_Tabs_Main";
const TopicPageViewsTabs = ()=>{
    var ref6;
    const { topicId , view  } = useParams();
    const { search  } = useLocation();
    const { q  } = parse(search);
    const currentView = String(view);
    // do not change `posts` to `leaves`
    const keyToData = q === "sections" ? "sections" : "posts";
    const variables = useMemo(()=>({
            posts: keyToData === "posts",
            sections: keyToData === "sections",
            topicId: Number(topicId)
        }), [
        keyToData,
        topicId
    ]);
    const archiveQuery = useTopicPage_Views_ArchiveQuery({
        skip: currentView !== "archive",
        variables,
        fetchPolicy: "cache-and-network"
    });
    const trashQuery = useTopicPage_Views_TrashQuery({
        skip: currentView !== "trash",
        variables,
        fetchPolicy: "cache-and-network"
    });
    const { loading , data , error , fetchMore , updateQuery  } = currentView === "archive" ? archiveQuery : trashQuery;
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const pathToData = topic === null || topic === void 0 ? void 0 : topic[keyToData];
    const pageInfo = pathToData === null || pathToData === void 0 ? void 0 : pathToData.pageInfo;
    const { endCursor =null , hasNextPage =false  } = pageInfo || {};
    const isInitialLoad = loading && !topic;
    useLoadingProgress(isInitialLoad);
    const loadMore = useCallback(()=>{
        fetchMore({
            variables: _objectSpread({}, variables, {
                endCursor
            }),
            updateQuery (prevResult, { fetchMoreResult  }) {
                var ref, ref3, ref4, ref5;
                const fetchMoreResultsNodes = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref = fetchMoreResult.topic) === null || ref === void 0 ? void 0 : (ref3 = ref[keyToData]) === null || ref3 === void 0 ? void 0 : ref3.nodes;
                const fetchMoreResultsPageInfo = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref4 = fetchMoreResult.topic) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[keyToData]) === null || ref5 === void 0 ? void 0 : ref5.pageInfo;
                if (fetchMoreResultsNodes && fetchMoreResultsPageInfo) return update(prevResult, {
                    topic: {
                        [keyToData]: {
                            nodes: {
                                $push: fetchMoreResultsNodes
                            },
                            pageInfo: {
                                $set: fetchMoreResultsPageInfo
                            }
                        }
                    }
                });
                return prevResult;
            }
        });
    }, [
        endCursor,
        fetchMore,
        keyToData,
        variables
    ]);
    const updateList = useCallback((itemIds)=>{
        updateQuery((prevResult)=>{
            return update(prevResult, {
                topic: {
                    [keyToData]: {
                        nodes: {
                            $apply: (nodes)=>nodes.filter(({ id  })=>{
                                    if (typeof itemIds === "number") return id !== itemIds;
                                    return !itemIds.includes(id);
                                })
                        }
                    }
                }
            });
        });
    }, [
        keyToData,
        updateQuery
    ]);
    if (isInitialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!topic || topic.type !== ItemType.Topic || !topic.isRootTopic || ((ref6 = topic.rootTopicOrSelf) === null || ref6 === void 0 ? void 0 : ref6.special) === "PROFILE") return /*#__PURE__*/ _jsx(NotFound, {});
    if (currentView === "trash") {
        var ref1, ref2;
        const memberLevel = (ref1 = topic.rootTopicOrSelf) === null || ref1 === void 0 ? void 0 : ref1.memberLevel;
        const isPartOfTopic = memberLevel ? ![
            ItemMemberLevel.Invited,
            ItemMemberLevel.Pending
        ].includes(memberLevel) : false;
        if (!isPartOfTopic) return /*#__PURE__*/ _jsx(Redirect, {
            to: getItemUrl(topic, (ref2 = topic.rootTopicOrSelf) === null || ref2 === void 0 ? void 0 : ref2.owner)
        });
    }
    const { title , linkImages , description , id: id1  } = topic;
    const metaTagImage = linkImages && linkImages[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            currentView === "archive" && /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: ItemType.Topic,
                data: {
                    itemId: id1,
                    view: "ARCHIVE"
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: title ? `${title} (${currentView === "archive" ? "Archived" : "Trash"}) | Sprout` : "Sprout",
                description: description,
                image: metaTagImage
            }),
            /*#__PURE__*/ _jsx(TopicPagePage, {
                topic: topic,
                main: /*#__PURE__*/ _jsx(TopicPageViewsTabsMain, {
                    topic: topic,
                    hasNextPage: hasNextPage,
                    loading: loading,
                    loadMore: loadMore,
                    type: keyToData === "sections" ? ItemType.Topic : ItemType.Post,
                    updateList: updateList
                })
            })
        ]
    });
};
export default TopicPageViewsTabs;
